/**
 *
 * Styles for Tabs
 *
 */

import styled from "styled-components";

export const TabTitleList = styled.ul`
  list-style: none;
  display: flex;
  padding: 0;
  margin-bottom: 0;
`;

export const TabTitleFullBleed = styled.div`
  width: 100%;
  padding: var(--dui-size-space-10x) 0 0;
`;
